import React from "react";

import {pluralize, priceFormat} from "@pg-mono/string-utils";
import {Country} from "@pg-rp/common-types";

import {getParkingPlacesType, IParkingPlace} from "../../types/property/IParkingPlace";
import {VendorType} from "../../types/property/IVendor";

interface IProps {
    parking_places: IParkingPlace[];
    investor: string | null;
    vendor: {
        type: VendorType;
        name: string;
    };
    country: Country;
    offerName: string;
}

const parkingPlacesQuantity = pluralize(["miejsce", "miejsca", "miejsc"]);

export const renderParkingPlacesGenericText = (isParkingPlaces: boolean, offerInvestmentName: string, renderParkingPlaces?: React.ReactNode) => {
    if (!isParkingPlaces) {
        return <p>Dla przyszłych mieszkańców {offerInvestmentName} deweloper nie przewidział miejsc postojowych.</p>;
    }

    return (
        <p>
            {`Dla przyszłych mieszkańców ${offerInvestmentName} deweloper przewidział${renderParkingPlaces ? " " : ":"}`}
            {renderParkingPlaces}
        </p>
    );
};

export const OfferGeneratedDescriptionParkingPlaces = (props: IProps) => {
    const {parking_places, country, offerName} = props;

    const isParkingPlaces = parking_places.length > 0;

    if (!isParkingPlaces) {
        return renderParkingPlacesGenericText(isParkingPlaces, offerName);
    }

    return (
        <>
            {renderParkingPlacesGenericText(isParkingPlaces, offerName)}

            <ul>
                {parking_places.map((parkingPlace, index) => (
                    <li key={parkingPlace.id ?? `parking-place-${parkingPlace.type}-${index}`} className="fs16 mb-sm">
                        {`${getParkingPlacesType(parkingPlace.type).toLowerCase()} ${
                            parkingPlace.quantity ? `(${parkingPlace.quantity} ${parkingPlacesQuantity(parkingPlace.quantity)})` : ""
                        } ${
                            typeof parkingPlace.price === "number" && Number.isFinite(parkingPlace.price)
                                ? ` w cenie ${priceFormat(parkingPlace.price, {unit: country === Country.POLAND ? "zł" : "eur"})}`
                                : ""
                        }`}
                    </li>
                ))}
            </ul>
        </>
    );
};
import React from "react";

import {pluralize, priceFormat} from "@pg-mono/string-utils";
import {Country} from "@pg-rp/common-types";

import {getParkingPlacesType, IParkingPlace} from "../../types/property/IParkingPlace";
import {VendorType} from "../../types/property/IVendor";

interface IProps {
    parking_places: IParkingPlace[];
    investor: string | null;
    vendor: {
        type: VendorType;
        name: string;
    };
    country: Country;
    offerName: string;
}

const parkingPlacesQuantity = pluralize(["miejsce", "miejsca", "miejsc"]);

export const renderParkingPlacesGenericText = (isParkingPlaces: boolean, offerInvestmentName: string, renderParkingPlaces?: React.ReactNode) => {
    if (!isParkingPlaces) {
        return <p>Dla przyszłych mieszkańców {offerInvestmentName} deweloper nie przewidział miejsc postojowych.</p>;
    }

    return (
        <p>
            {`Dla przyszłych mieszkańców ${offerInvestmentName} deweloper przewidział${renderParkingPlaces ? " " : ":"}`}
            {renderParkingPlaces}
        </p>
    );
};

export const OfferGeneratedDescriptionParkingPlaces = (props: IProps) => {
    const {parking_places, country, offerName} = props;

    const isParkingPlaces = parking_places.length > 0;

    if (!isParkingPlaces) {
        return renderParkingPlacesGenericText(isParkingPlaces, offerName);
    }

    return (
        <>
            {renderParkingPlacesGenericText(isParkingPlaces, offerName)}

            <ul>
                {parking_places.map((parkingPlace, index) => (
                    <li key={parkingPlace.id ?? `parking-place-${parkingPlace.type}-${index}`} className="fs16 mb-sm">
                        {`${getParkingPlacesType(parkingPlace.type).toLowerCase()} ${
                            parkingPlace.quantity ? `(${parkingPlace.quantity} ${parkingPlacesQuantity(parkingPlace.quantity)})` : ""
                        } ${
                            typeof parkingPlace.price === "number" && Number.isFinite(parkingPlace.price)
                                ? ` w cenie ${priceFormat(parkingPlace.price, {unit: country === Country.POLAND ? "zł" : "eur"})}`
                                : ""
                        }`}
                    </li>
                ))}
            </ul>
        </>
    );
};
